module.exports = __webpack_public_path__ + "img/News-Announcement-PC.8ccd802f.png";